import React from 'react'
import LgyInputField from './LgyInputField'

const phoneMask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]

const LgyPhoneInputField = (props) =>
  <LgyInputField {...props} mask={phoneMask} guide={false} />

export default LgyPhoneInputField

